export const getRequisitionState = ({
  currUser,
  feReq,
  requisitions,
  showLegacyFlowDynamically = false,
  hasExistingRequisitions,
  switched_to_new_req = false,
}) => {
  // Calculate derived values
  const userHasReqEnabled = currUser?.requisition?.enabled && feReq;
  const hasExistingRequisitionsWithRole = requisitions?.some((req) =>
    Boolean(req?.role_name)
  );

  // Logic for different scenarios:
  // 1. User has req enabled + No existing requisitions → AssociateReq flow
  // 2. User has req enabled + Has existing requisitions with role_name → AssociateReq flow
  // 3. User has req enabled + Has existing requisitions but NO role_name → Legacy flow
  // 4. User has NO req enabled + Has existing requisitions with role_name → AssociateReq (read-only)
  // 5. User has NO req enabled + No existing requisitions → Legacy flow

  const shouldUseAssociateReq =
    userHasReqEnabled && (switched_to_new_req || requisitions.length === 0);

  const shouldUseLegacyFlow =
    (userHasReqEnabled &&
      !switched_to_new_req &&
      !hasExistingRequisitionsWithRole &&
      requisitions.length > 0) ||
    (!userHasReqEnabled && !switched_to_new_req);

  return {
    shouldUseAssociateReq,
    shouldUseLegacyFlow,
    userHasReqEnabled,
    hasExistingRequisitionsWithRole,
  };
};

export const getRequisitionStateOffer = ({
  currUser,
  feReq,
  requisitions,
  showLegacyFlowDynamically = false,
  showInputField = false,
}) => {
  const userHasReqEnabled = currUser?.requisition?.enabled && feReq;
  const hasExistingRequisitionsWithRole = requisitions?.some((req) =>
    Boolean(req?.role_name)
  );

  const shouldUseAssociateReq =
    !showLegacyFlowDynamically &&
    (!showInputField || hasExistingRequisitionsWithRole);

  const shouldUseLegacyFlow =
    showLegacyFlowDynamically ||
    (showInputField && !hasExistingRequisitionsWithRole);

  return {
    shouldUseAssociateReq,
    shouldUseLegacyFlow,
    userHasReqEnabled,
    hasExistingRequisitionsWithRole,
  };
};
